import { IRootState } from "../reducers/root";
import { ILanguage } from "../../model/localization/ILanguage";

export function selectLanguage(state: IRootState): ILanguage {
    document.documentElement.lang = state.localization.language.code;
    return state.localization.language;
}
